<template>
  <transition name="modal" appear>
    <div class="c-modal__overlay" v-on:click="$emit('close')">
      <div class="c-modal__window" v-on:click="eventCansel">
        <span class="c-modal__window--close" v-on:click="$emit('close')"></span>
        <div class="c-modal__content">
          <slot/>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    modal: Boolean
  },
  methods: {
    eventCansel: function (ev) {
      ev.stopPropagation()
    }
  }
}
</script>

<style lang="sass" scoped>

</style>
